import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";


const useUpdateLicenses = () => {
const { token } = useContext(AuthContext);
const [error, setError] = useState(null);
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState(null);
const navigate = useNavigate()

const handleSubmit = async (e, formData) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
        const formDataToSend = new FormData();

        
        formData.forEach((doc) => {
            formDataToSend.append(doc.name, doc.file);
        });

        const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/update/licenses`, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formDataToSend,
        });

        const resData = await res.json();

        if (!res.ok) {
            throw new Error(resData.message);
        }

        setLoading(false);
        setSuccess("Files updated successfully");
        setTimeout(() => {
            setSuccess(false);
            navigate("/typeofupdate")
        }, 3000);
    } catch (error) {
        setError(error.message);
        setLoading(false);
    }
};


return {
    handleSubmit,
    loading,
    error,
    success,
};
};

export default useUpdateLicenses;
